import React, { Component } from 'react'
import '../styles/ActivityDetailsView.css'
import CalendarActivity from './CalendarActivity'
import EncodeAttendance from './EncodeAttendance'

class ActivityDetailsView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			isViewDetails: props.isViewDetails,
			activityId: props.activityId
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.setContent = this.setContent.bind(this)
		this.onSignal = this.onSignal.bind(this)
	}

	onSubmit() {
	}

	componentDidMount() {
		this.setContent(sessionStorage.getItem("activity-tabId"))
	}

	setContent(id) {
		let content
		switch(id) {
			case "adh-attendance":
				content = <EncodeAttendance activityId={this.state.activityId} />
				break
			default:
				content = <CalendarActivity onSignal={this.onSignal}
					isUpdate={true} activityId={this.state.activityId} />
		}
		if(this.state.activityId == null || (this.props.status != 2 && this.props.status != 3)) {
			var disabled = true
		}
		this.setState({content: content, disabled: disabled})
	}

	onSignal(view) {
		this.props.onSignal(view)
	}

	render() {
		const view = <div id="activity-view-details">
			<Header onItemClick={(item) => {
				this.setContent(item)
			}} disabled={this.state.disabled} />
			<Body content={this.state.content} />
		</div>
		return(view)
	}
}

class Header extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			disabled: (props.disabled == null)? false: props.disabled
		}
		this.onItemClick = this.onItemClick.bind(this)
		this.mouseEnter = this.mouseEnter.bind(this)
		this.mouseLeave = this.mouseLeave.bind(this)
	}

	componentDidMount() {
		if(this.state.disabled) {
			return
		}
		document.getElementById('adh-attendance').style.color = "#000"
		const tabId = sessionStorage.getItem("activity-tabId")
		switch(tabId) {
			case "adh-attendance":
				var elem = document.getElementById(tabId)
				elem.style.background = "#e2e2e2"
				break
			default:
				elem = document.getElementById("adh-activity")
				elem.style.background = "#e2e2e2"
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.disabled != prevProps.disabled) {
			this.setState({disabled: this.props.disabled})
			if(this.props.disabled) {
				document.getElementById('adh-attendance').style.color = "#e2e2e2"
				return
			}
			document.getElementById('adh-attendance').style.color = "#646464"
		}
	}

	onItemClick(e) {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('#activity-details-header > div')
		for(const f of items) {
			f.style.background = "#ffffff"
		}
		e.target.style.background = "#e2e2e2"
		this.props.onItemClick(e.target.id)
	}

	mouseEnter(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#e2e2e280"
	}

	mouseLeave(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#ffffff"
	}

	render() {
		const view = <div id="activity-details-header">
			<div id="adh-activity" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>ACTIVITY DETAILS</div>
			<div id="adh-attendance" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>ATTENDANCE</div>
		</div>
		return(view)
	}
}

class Body extends Component
{
	constructor(props) {
		super(props)
		this.onItemClick = this.onItemClick.bind(this)
	}

	onItemClick(e) {
		console.log(e.target.id)
	}

	render() {
		const view = <div id="activity-details-body">
			<div id="adb-content">
				{this.props.content}
			</div>
		</div>
		return(view)
	}
}

export default ActivityDetailsView
